import React, { useState, useEffect } from 'react';
import DashboardLayout from '../Dashboard/layout';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import "./IndustryPage.css";
import axios from 'axios';
import { ADDBTN, Headings, SerchInput, UserSelect } from '../RegisteredUsersList/ViewRegList';
import { FaAngleDoubleLeft , FaAngleDoubleRight } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { FiEdit } from "react-icons/fi";


const ViewIndustryPageList = () => {
  const [industries, setIndustries] = useState([]);
  const [filteredIndustries, setFilteredIndustries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [industriesPerPage] = useState(5); // Number of industries per page
  const navigate = useNavigate();

  // Simulating an API call to fetch industries
  useEffect(() => {
    const fetchIndustries = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/admin/industries`);
        const data = await response.json();
        
       // console.log('Fetched industries:', data);
        
        if (Array.isArray(data.industries)) { 
          setIndustries(data.industries); 
          setFilteredIndustries(data.industries);  
        } else {
          console.error('Data is not an array:', data);
        }
      } catch (error) {
        console.error('Failed to fetch industries:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchIndustries();
  }, []);

  useEffect(() => {
    let filtered = industries;

    if (selectedStatus) {
      // Adjust to match status as integers (1 = Active, 0 = Inactive)
      filtered = filtered.filter((industry) => industry.status === parseInt(selectedStatus)); 
    }

    if (searchQuery) {
      filtered = filtered.filter(
        (industry) =>
          industry.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    setFilteredIndustries(filtered);
    setCurrentPage(1); // Reset to first page when filters or search query changes
  }, [selectedStatus, searchQuery, industries]);


  const handleDeleteIndustry = async (industryId) => {
    try {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this industry!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      });
  
      if (result.isConfirmed) {
        // Send delete request to the server
        await axios.delete(`${process.env.REACT_APP_BASE_URL}api/admin/industries/${industryId}`);
        setIndustries((prevIndustries) => prevIndustries.filter((industry) => industry._id !== industryId));
  
        Swal.fire('Deleted!', 'The industry has been deleted.', 'success');
      }
    } catch (error) {
      console.error('Error deleting industry:', error);
      Swal.fire('Error!', 'Failed to delete the industry. Please try again.', 'error');
    }
  };
  

  const handleEditIndustry = (industryId) => {
    navigate(`/edit-industry/${industryId}`); 
  };

  // Pagination logic
  const indexOfLastIndustry =  (currentPage - 1) * industriesPerPage;
  //const indexOfFirstIndustry = indexOfLastIndustry - industriesPerPage;
  const currentIndustries = filteredIndustries.slice(indexOfLastIndustry, indexOfLastIndustry+industriesPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(filteredIndustries.length / industriesPerPage);

  const handleAddIndustryClick = () => {
    navigate('/add-industry'); // Navigate to Add Industry page
  };

  const statusOptions = [
    { value: '', label: 'All' },
    { value: '1', label: 'Active' },
    { value: '0', label: 'Inactive' },
  ];

  return (
    <>
      <DashboardLayout>

        <section className="MainDivSec">

          <Headings headspan="Industry" hedtext=" List" />

          <div className="TopSelctDiv">
            <div className="LeftSlct">
              <UserSelect slctvluename="Filter by Status:" selectedRole={selectedStatus} slctonchange={(e) => setSelectedStatus(e.target.value)} options={statusOptions} slcthtmlfor="statusFilter" />
            </div>
            <div className="RytSrch">
              <SerchInput searchvalue={searchQuery} searchonchange={(e) => setSearchQuery(e.target.value)} srchid="searchQuery" srchplcehldr="Search by name" />
              <ADDBTN adtext="Add Industry" adonclick={handleAddIndustryClick}/>
            </div>
          </div>

          <div className="TableSec">

            {loading ? (
              <p className="Loadingpara">Loading...</p>
            ) : (
            <>

            <div className="UserTableDiv">
              <table className="User_Table">
                <thead>
                  <tr>
                    <th>SR NO</th>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                {currentIndustries.length > 0 ? (
                  currentIndustries.map((industry, index) => (
                    <tr key={industry._id}>
                      <td>{indexOfLastIndustry+index + 1}</td>
                      <td>{industry.name}</td>
                      <td>{industry.status === 1 ? 'Active' : 'Inactive'}</td>

                      <td className='EditDelteDiv'>
                        <button onClick={() => handleEditIndustry(industry._id)}><FiEdit /></button>
                        <button
                          className="delete-btn"
                          onClick={() => handleDeleteIndustry(industry._id)}
                        >
                         <MdDelete />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">Industries not found.</td>
                  </tr>
                )}
              </tbody>
              </table>
            </div>

            <div className="Tablepagination">
                <button onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1} >
                  <FaAngleDoubleLeft/>
                </button>
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index + 1}
                    onClick={() => paginate(index + 1)}
                    className={currentPage === index + 1 ? "active" : ""}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}>
                  <FaAngleDoubleRight />
                </button>
            </div>

            </>
            )}
          </div>
          

        </section>
      </DashboardLayout>
    </>
  );
};

export default ViewIndustryPageList;
